import React from "react";
import "./ToolPrepSourceCards.css";

/**
 * Overlays on the Original thumb:
 * - Remove (X) — always visible, top-right (matches ToolPrepPopup close)
 * - Replace — appears on hover
 */
export function ToolPrepOriginalOverlays({
  onReplace = null,
  onRemove = null,
  disabled = false,
  showActions = true,
}) {
  if (!showActions || typeof onRemove !== "function") return null;

  const stop = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <>
      <button
        type="button"
        className="tool-prep-source-cards__remove-x"
        onClick={(event) => {
          stop(event);
          if (!disabled) onRemove(event);
        }}
        disabled={disabled}
        aria-label="Remove image"
      >
        <svg
          className="tool-prep-source-cards__remove-x-icon"
          viewBox="0 0 14 14"
          width="12"
          height="12"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M1 1l12 12M13 1L1 13"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
          />
        </svg>
      </button>
      {typeof onReplace === "function" ? (
        <button
          type="button"
          className="tool-prep-source-cards__replace"
          onClick={(event) => {
            stop(event);
            if (!disabled) onReplace(event);
          }}
          disabled={disabled}
          aria-label="Replace image"
        >
          Replace
        </button>
      ) : null}
    </>
  );
}
